import PropTypes from 'prop-types';

const titleTable = ['id', 'name', 'description', 'translations'];
export default { titleTable }
